import { createContext } from "react";

import { type RecognizedUserProviderState } from "./contract";

const RecognizedUserContext = createContext<
  RecognizedUserProviderState | undefined
>(undefined);

export default RecognizedUserContext;
